import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Modal, Card } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/css/contact-us.css"; // Create this CSS file for custom styles

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validated, setValidated] = useState(false);

  // Initialize AOS animation library
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    
    setIsSubmitting(true);
    setValidated(true);
    
    try {
      const response = await fetch('/contact-form.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const result = await response.json();
      if (result.status === 200) {
        setShowSuccessModal(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
        setValidated(false);
      } else {
        setShowFailureModal(true);
      }
    } catch (error) {
      setShowFailureModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="contact-page-wrapper py-5" id="formsubmission">
      <Container>
        <div className="text-center mb-5" data-aos="fade-up">
          <h1 className="display-4 fw-bold text-primary brand-heading">Get in Touch</h1>
          <p className="lead">We're here to help with all your air conditioning needs</p>
          <div className="divider-custom my-3">
            <div className="divider-line"></div>
            <div className="divider-icon"><i className="bi bi-fan"></i></div>
            <div className="divider-line"></div>
          </div>
        </div>
        
        <Row className="g-4">
          {/* Contact Info Section */}
          <Col lg={5} md={6} data-aos="fade-right" data-aos-delay="100">
            <Card className="contact-card shadow h-100 border-0">
              <Card.Body className="p-4">
                <div className="contact-header mb-4">
                  <span className="contact-icon-wrapper">
                    <i className="bi bi-building"></i>
                  </span>
                  <h2 className="mb-3">Contact Information</h2>
                </div>
                
                <div className="company-info mb-4">
                  <h4 className="mb-2">Breath Comfort Air Systems</h4>
                  <address className="mb-3">
                    <p className="text-muted mb-1">No. 9 Venkateshwara Nagar, Sethu Street</p>
                    <p className="text-muted">Madhanandhapuram, Chennai 600125</p>
                  </address>
                </div>
                
                <div className="contact-links mb-4">
                  <div className="contact-link-item">
                    <i className={window.innerWidth > 768 ? "bi bi-whatsapp me-2 contact-icon" : "bi bi-telephone-fill me-2 contact-icon"}></i>
                    <a href={window.innerWidth > 768 ? "https://wa.me/+917358052100" : "tel:+917358052100"} className="contact-link" target="blank">{window.innerWidth > 768 ? "+91 7358052100 (WhatsApp)" : "+91 7358052100"}</a>
                  </div>
                  <div className="contact-link-item">
                    <i className="bi bi-envelope-fill me-2 contact-icon"></i>
                    <a href="mailto:admin@breathcomfort.in" className="contact-link" target="blank">admin@breathcomfort.in</a>
                  </div>
                  <div className="contact-link-item">
                    <i className="bi bi-globe me-2 contact-icon"></i>
                    <a href="https://www.breathcomfort.in" className="contact-link"  >www.breathcomfort.in</a>
                  </div>
                </div>

                {/* <div className="business-hours mb-4">
                  <h4 className="mb-3"><i className="bi bi-clock me-2"></i> Business Hours</h4>
                  <ul className="list-unstyled hours-list">
                    <li><span>Monday - Friday:</span> <span>9 AM – 6 PM</span></li>
                    <li><span>Saturday:</span> <span>10 AM – 4 PM</span></li>
                    <li><span>Sunday:</span> <span>Closed</span></li>
                  </ul>
                </div> */}

                <div className="emergency-support p-3 rounded">
                  <h4><i className="bi bi-headset me-2"></i> 24/7 Support</h4>
                  <p className="mb-2">Need immediate assistance?</p>
                  <a href="tel:+917358052100" className="emergency-phone">
                    <i className="bi bi-phone-fill me-2"></i> +91 7358052100
                  </a>
                </div>
                
                {/* <div className="social-links mt-4">
                  <h5>Connect With Us</h5>
                  <div className="d-flex gap-2 mt-2">
                    <a href="#" className="social-icon"><i className="bi bi-facebook"></i></a>
                    <a href="#" className="social-icon"><i className="bi bi-instagram"></i></a>
                    <a href="#" className="social-icon"><i className="bi bi-twitter-x"></i></a>
                    <a href="#" className="social-icon"><i className="bi bi-linkedin"></i></a>
                  </div>
                </div> */}
              </Card.Body>
            </Card>
          </Col>

          {/* Contact Form */}
          <Col lg={7} md={6} data-aos="fade-left" data-aos-delay="200">
            <Card className="form-card shadow h-100 border-0">
              <Card.Body className="p-4 p-lg-5">
                <div className="form-header mb-4">
                  <span className="form-icon-wrapper">
                    <i className="bi bi-chat-dots"></i>
                  </span>
                  <h2>Send Us a Message</h2>
                  <p className="text-muted">Fill out the form below and we'll get back to you shortly</p>
                </div>
                
                <Form noValidate validated={validated} onSubmit={handleSubmit} className="contact-form">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3 form-floating">
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          placeholder="Your Name"
                          required
                          value={formData.name}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                        <Form.Label htmlFor="name">Full Name *</Form.Label>
                        <Form.Control.Feedback type="invalid">
                          Please provide your name
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                      <Form.Group className="mb-3 form-floating">
                        <Form.Control
                          type="tel"
                          name="phone"
                          id="phone"
                          placeholder="Your Phone"
                          required
                          value={formData.phone}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                        <Form.Label htmlFor="phone">Phone Number *</Form.Label>
                        <Form.Control.Feedback type="invalid">
                          Please provide your phone number
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3 form-floating">
                    <Form.Control
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Your Email"
                      required
                      value={formData.email}
                      onChange={handleInputChange}
                      className="form-input"
                    />
                    <Form.Label htmlFor="email">Email Address *</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid email address
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4 form-floating">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      id="message"
                      placeholder="Your Message"
                      required
                      value={formData.message}
                      onChange={handleInputChange}
                      className="form-input"
                      style={{ height: "150px" }}
                    />
                    <Form.Label htmlFor="message">Your Message *</Form.Label>
                  </Form.Group>

                  <Button 
                    type="submit" 
                    className="btn-submit w-100 py-3" 
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-send me-2"></i> Send Message
                      </>
                    )}
                  </Button>

                  <p className="text-center text-muted mt-3">
                    <i className="bi bi-clock-history me-1"></i> We typically respond within 24 hours
                  </p>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Map Section
        <Row className="mt-5" data-aos="fade-up" data-aos-delay="300">
          <Col>
            <Card className="map-card shadow border-0">
              <Card.Body className="p-4">
                <div className="location-header mb-3 d-flex align-items-center">
                  <span className="location-icon-wrapper me-3">
                    <i className="bi bi-geo-alt"></i>
                  </span>
                  <h2 className="mb-0">Find Us</h2>
                </div>
                <div className="map-container">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d62506.00321765945!2d78.9621680925293!3d11.720936452908132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1741507976349!5m2!1sen!2sin" 
                    style={{ border: "0", height: "450px" }} 
                    allowFullScreen 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade" 
                    className="w-100 rounded map-frame"
                    title="Google Map"
                  ></iframe>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
      </Container>

      {/* Success Modal */}
      <Modal 
        show={showSuccessModal} 
        onHide={() => setShowSuccessModal(false)} 
        centered
        className="result-modal"
      >
        <Modal.Body className="text-center p-5">
          <div className="modal-icon-success mb-4">
            <i className="bi bi-check-circle"></i>
          </div>
          <h3>Thank You!</h3>
          <p className="mb-4">Your message has been sent successfully. We'll get back to you within 24 hours.</p>
          <Button 
            variant="primary" 
            onClick={() => setShowSuccessModal(false)}
            className="btn-modal"
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>

      {/* Failure Modal */}
      <Modal 
        show={showFailureModal} 
        onHide={() => setShowFailureModal(false)} 
        centered
        className="result-modal"
      >
        <Modal.Body className="text-center p-5">
          <div className="modal-icon-failure mb-4">
            <i className="bi bi-x-circle"></i>
          </div>
          <h3>Oops!</h3>
          <p className="mb-4">There was an issue sending your message. Please try again later or contact us directly.</p>
          <Button 
            variant="primary" 
            onClick={() => setShowFailureModal(false)}
            className="btn-modal"
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ContactUs;